// extracted by mini-css-extract-plugin
export default {"root":"heatmapDevices_root__2BY3K","loaderContainer":"heatmapDevices_loaderContainer__zhmMc","tooltip":"heatmapDevices_tooltip__11CIY"};